export const CORES_PRESET = [
  { nome:"Branco", hex:"#FFFFFF" }, { nome:"Preto", hex:"#1a1a1a" },
  { nome:"Cinza", hex:"#888888" }, { nome:"Prata", hex:"#C0C0C0" },
  { nome:"Vermelho", hex:"#e63946" }, { nome:"Laranja", hex:"#ff6b35" },
  { nome:"Amarelo", hex:"#ffd166" }, { nome:"Verde", hex:"#06d6a0" },
  { nome:"Azul", hex:"#118ab2" }, { nome:"Azul Claro", hex:"#90e0ef" },
  { nome:"Roxo", hex:"#7b5ea7" }, { nome:"Rosa", hex:"#ff85a1" },
  { nome:"Marrom", hex:"#7c4c2b" }, { nome:"Transparente", hex:"transparent" },
];
